import { ApiErrorCatalog, ResolveApiErrorProps } from '../core/api-error';
import { Failure } from '../core/failure';

export enum ConversationsRepositoryFailureTypes {
  failToComunicateWithTheServer,
  outOfConversationWindow,
}

export class ConversationsRepositoryFailure extends Failure<
  ConversationsRepositoryFailureTypes,
  void
> {
  private constructor(errorMessage: string, errorType: ConversationsRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new ConversationsRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      ConversationsRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new ConversationsRepositoryFailure(
      'Falha ao acessar dados',
      ConversationsRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static outOfConversationWindow() {
    return new ConversationsRepositoryFailure(
      'A janela de 24h desta conversa está encerrada. Envie um template aprovado para reabri-la.',
      ConversationsRepositoryFailureTypes.outOfConversationWindow
    );
  }
}
